import { ChartType } from "../../models/enum/chart-type.enum";

export class ChartTypeToEnumMapper {
    static map(chartTypeString: string) {
        const value = chartTypeString?.trim()?.toLowerCase() ?? '';
        switch (value) {
            case 'candlestick': {
                return ChartType.Candlestick;
            }
            case 'area' : {
                return ChartType.Area;
            }
            case 'bar' : {
                return ChartType.Bar;
            }
            case 'line' : {
                return ChartType.Line;
            }
            case 'ohlc' : {
                return ChartType.OHLC;
            }
            case 'hlc' : {
                return ChartType.HLC;
            }
            default: {
                throw  new Error(`chart type string not supported yet: ${chartTypeString}`);
            }
        }
    }
}